<script setup lang="ts">
import { Button as VarButton, type ButtonProps } from '@varlet/ui';

// eslint-disable-next-line vue/define-props-destructuring
const props = defineProps<ButtonProps>();
</script>

<template>
  <VarButton v-bind="props">
    <slot />
  </VarButton>
</template>

<style lang="scss">
.var-button {
  border-radius: var(--button-border-radius);
  transition:
    transform 160ms ease,
    box-shadow 160ms ease,
    background-color 160ms ease,
    border-color 160ms ease;

  &--primary:not(&--disabled) {
    --button-primary-gradient-light: color-mix(in srgb, var(--button-primary-color), white 20%);

    background: linear-gradient(
      135deg,
      var(--button-primary-color) 0%,
      var(--button-primary-gradient-light) 100%
    );
    box-shadow:
      0 14px 28px color-mix(in srgb, var(--button-primary-color), transparent 72%),
      inset 0 1px 0 rgba(255, 255, 255, 0.16);

    &:active {
      transform: translateY(1px);
      filter: brightness(0.95);
    }
  }

  &--default {
    color: var(--theme-text-primary);
    background-color: var(--theme-control-surface);
    border: 1px solid var(--theme-border-strong);

    &:hover:not(&--disabled) {
      background-color: var(--theme-control-hover);
    }

    &:active:not(&--disabled) {
      transform: translateY(1px);
    }
  }
}
</style>
